import { render } from "./CvDownload.vue?vue&type=template&id=16544193&scoped=true"
import script from "./CvDownload.vue?vue&type=script&lang=js"
export * from "./CvDownload.vue?vue&type=script&lang=js"

import "./CvDownload.vue?vue&type=style&index=0&id=16544193&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16544193"

export default script